import axios from 'axios';

export default ({ id }) => {
  const data = {
    purchase_questionnaire_submitted: true,
  };
  const purchaseData = Object.entries(data).reduce((a, [k, v]) => (v == null ? a : ((a[k] = v), a)), {});
  return axios.patch(`${process.env.VUE_APP_API_ENDPOINT}/purchases/${id}`, purchaseData);
};
